import { HOST_BONUS } from './elo';
import { lambdaFor, samplePoisson } from './goals';
import {
  currentAbsences,
  teamPenalty,
  isEngineAbsencesEnabled,
  DEFAULT_ABSENCE_WEIGHTS,
} from './absences';
import { liveSuspensions } from './state';

export const RECENT_ALPHA = 0.20;
const RECENT_CAP_ELO = 150;

export function recentFormAdjustment(team) {
  if (team.elo_1y_ago == null) return 0;
  const adj = RECENT_ALPHA * (team.elo - team.elo_1y_ago);
  return Math.max(-RECENT_CAP_ELO, Math.min(RECENT_CAP_ELO, adj));
}

export function absenceAdjustment(team, stage = 'group') {
  if (!isEngineAbsencesEnabled()) return 0;
  const list = [...currentAbsences(team.id), ...liveSuspensions(team.id)];
  if (list.length === 0) return 0;
  return teamPenalty(list, DEFAULT_ABSENCE_WEIGHTS, stage);
}

let customEloAdjustments = {};
export function setCustomEloAdjustments(map) {
  customEloAdjustments = map || {};
}

/** Effective ELO for live simulation = base ELO + recent-form + absences + custom adjustments. */
export function effectiveElo(team, stage = 'group') {
  const base = team.elo + recentFormAdjustment(team) + absenceAdjustment(team, stage);
  const custom = customEloAdjustments[team.id] || 0;
  return base + custom;
}

export function hostBonus(team, isKnockout) {
  if (isKnockout) return 0;
  return team.is_host ? HOST_BONUS : 0;
}

export const FATIGUE_LAMBDA_FACTOR = 0.92;

/** Sample a regulation-time score (goals_a, goals_b) for a match between teams a and b. */
export function sampleScore(
  a,
  b,
  rng,
  isKnockout,
  stage = 'group',
  fatigueA = false,
  fatigueB = false,
) {
  const eloA = effectiveElo(a, stage);
  const eloB = effectiveElo(b, stage);
  const bonusA = hostBonus(a, isKnockout);
  const bonusB = hostBonus(b, isKnockout);
  let lambdaA = lambdaFor(eloA, eloB, bonusA);
  let lambdaB = lambdaFor(eloB, eloA, bonusB);
  if (fatigueA) lambdaA *= FATIGUE_LAMBDA_FACTOR;
  if (fatigueB) lambdaB *= FATIGUE_LAMBDA_FACTOR;
  return {
    ga: samplePoisson(lambdaA, rng),
    gb: samplePoisson(lambdaB, rng),
  };
}
